import { Component, OnInit } from '@angular/core';
import { DynamicScriptLoaderService } from './services/dynamic-script-loader.service';
import { SpinnerService } from './core/spinner/spinner.service';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Tower Hill Insurance';
  showLoader: boolean;

  constructor(private spinner: SpinnerService) {
  }

  ngOnInit() {
    this.spinner.status.subscribe(uiState => {
      setTimeout(() => {
        this.showLoader = uiState.actionOngoing;
      }, 10);
    });
  }
}
